import axios from "axios";
import { BASE_API } from "./entities";

export async function get_default_charges_from_bb(getstate) {
  // console.log("get_rate_profile_from_bb is executing: ")
  const isUserPresent =  getstate()?.route?.USER_DETAILS?.webuser?.userid != null
  // console.log("rateProfileId: ",rateProfileId,"isUserPresent: ",isUserPresent)
  let jwt_token;
  if(isUserPresent){
      jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  }else{
      jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
  }

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };

  const actionId = isUserPresent
    ? "b807b9ef853747eaad080064ca707670"
    : "d40c35b18d1b4edf8c2d9873167dbae0";

  const input = {};

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
      action_id: actionId,
      input,
    },
  };

  return axios.post(BASE_API, query, { headers }).then((result) => {
    // console.log("---results----",result)
    if (result?.data?.data?.action?.results) {
      const responseData = result?.data?.data?.action?.results || [];
      if (responseData) {
        return [200, responseData];
      }
    } else if (result?.data?.errors || result?.data?.data?.errors) {
      const errMsg =
        result.data.errors[0].message || result.data.data.errors[0].message;
      console.error(errMsg);
    }
    return [403, []];
  });
}